export var selectCanLoadMore = function selectCanLoadMore(state) {
  return state.favoritesAssignWidget.canLoadMore;
};